// Builds "?key=value&…" from an object. Falsy values are left out on purpose: callers
// rely on e.g. `pdfonly: false` being absent rather than sent as "pdfonly=false".
// Values are percent-encoded so a value containing "&", "=", "#", "+" or a space
// stays one parameter instead of splitting, truncating or ending the query.
export default (query = {}) => {
  const parts = []

  for (const key of Object.keys(query)) {
    if (query[key]) {
      parts.push(`${key}=${encodeURIComponent(query[key])}`)
    }
  }

  if (parts.length === 0) { return '' }

  return '?' + parts.join('&')
}
